import { render, staticRenderFns } from "./ArrowLeftLight.vue?vue&type=template&id=1e2a8bdc&scoped=true&"
import script from "./ArrowLeftLight.vue?vue&type=script&lang=js&"
export * from "./ArrowLeftLight.vue?vue&type=script&lang=js&"
import style0 from "./ArrowLeftLight.vue?vue&type=style&index=0&id=1e2a8bdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2a8bdc",
  null
  
)

export default component.exports